import React, { useEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { RootState } from '../../../setup';
import Pagination from '../layout/Pagination';
import { deleteUser, viewUserByRoleStatus } from '../../modules/auth/redux/AuthCRUD';
import { UserDbModel } from '../../modules/auth/models/UserModel';
import { AddEditUser } from './AddEditUser';

const ManageOnboarding: React.FC = () => {
    const { pathname } = useLocation();
    const history = useHistory();
    const { pageNo }: any = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<Array<UserDbModel>>();
    const [dataError, setDataError] = useState<{ error: string }>();
    const isMobile = useSelector<RootState>(({ auth }) => auth.isMobile, shallowEqual)
    const pageSize = 10;
    let pgNo = parseInt(pageNo);
    if (pgNo < 1 || Number.isNaN(pgNo)) {
        pgNo = 1
    }

    const start = (pgNo - 1) * pageSize;

    const fetchData = () => {
        setIsLoading(true);
        viewUserByRoleStatus('ADMIN', 'INACTIVE').then((result) => setData(result.data))
            .catch(e => setDataError({ error: "Server Error! Cannot fetch data!" }))
            .finally(() => setIsLoading(false));
    }

    useEffect(fetchData, []);

    if (isLoading) {
        return (
            <div>
                <br />
                <strong>
                    <span>Loading... Please wait... </span> <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </strong>
            </div>
        );
    }

    if (dataError || data == null) {
        return (
            <div className='card mb-5 mb-xl-10'>
                <div
                    className='card-header border-0'
                >
                    {dataError ? (
                        <div>
                            <br />
                            <div className='mb-lg-15 alert alert-danger d-flex flex-column-fluid flex-center'>
                                <div className='alert-text font-weight-bold'>{dataError.error}</div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <br />
                            <span>Loading... </span> <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    const onDelete = (id: string) => {
        if (!window.confirm('Are you sure want to delete?')) {
            return;
        }
        deleteUser(id).then(() => {
            setData(data?.filter(x => x.id != id));
        });
    }
    const manageUrlPrefix = `/v2/core/onboarding/manage`;

    return (
        <>
            <div className="bredcrumb-cnntr">
                <ul>
                    <li><Link to={`/v2/dashboard`}>Home</Link></li>
                    <li>Manage Onboarding</li>
                </ul>
            </div>
            <div className="site-head">
                <h1 className="main-title">Manage Onboarding</h1>
            </div>
            <div className="project-list">
                <table className="weblist-table add-manage-test">
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Designation</th>
                            <th scope="col">Mobile No</th>
                            <th scope="col" className="action">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.length > 0 ? null : 'No data to display'}
                        {data?.slice(start, start + pageSize).map(row => (
                            <tr>
                                <td className="website-name add-test">
                                    {row.parichay?.fullName} <br />
                                </td>
                                <td>{row.email}</td>
                                <td>{row.parichay?.designation}</td>
                                <td>{row.parichay?.mobileNo}</td>
                                <td className="action">
                                    {row.parichay?.hasOnboardingPdf ? (
                                    <Link className='btn'
                                        to={`/v2/core/users/downloadonboarding/${row.id}`}>
                                        Onboarding PDF
                                    </Link>): null} <br />
                                    <Link className='edit' data-target="#details-popup"
                                        to={`/v2/core/onboarding/edit/${row.id}`}>
                                        <em className="fa fa-check-circle-o" aria-hidden="true"></em>
                                    </Link>
                                    <Link className='edit'
                                        to={`#`}
                                        onClick={() => {
                                            onDelete(row.id);
                                        }}>
                                        <em className="fa fa-trash-o" aria-hidden="true"></em>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <nav aria-label="Page navigation" className="pagination-wrap">
                {data ?
                    <Pagination
                        currentPage={pgNo}
                        totalCount={data.length}
                        pageSize={pageSize}
                        infinite={false}
                        onPageChange={(page: number) => history.push(`/v2/core/onboarding/manage/${page}`)}
                    /> : null}
            </nav>
            <AddEditUser onSave={fetchData} manageUrlPrefix={manageUrlPrefix} isOnboarding={true} />
        </>
    )
}

export { ManageOnboarding }
